module.exports = __webpack_public_path__ + "img/sun-logo.f49c30e6.png";